import { TextField, TextFieldProps } from '../components/TextField'
import LabelledSwitch from '../components/LabelledSwitch'
import RadioGroup from '../components/RadioGroup'
import CheckboxGroup from '../components/CheckboxGroup'
import DateRange from '../components/DateRange'
import FroalaEditor from '../components/FroalaEditor'
import { CONTROL } from '../Constants'
import { setToolBuilder } from 'redux/slices/ToolBuilder'
import type { Dispatch } from 'redux'
import PermaLink from '../components/PermaLink'
import AdminEmails from '../components/AdminEmails'
import ControlledFieldGroup from '../components/ControlledFieldGroup'
import TextFieldWithPermaLink from '../components/TextFieldWithPermalink'

interface FeatureMapping {
  component: React.ComponentType<any>
  props: Record<string, any>
}

const featureMappings: Record<string, FeatureMapping> = {
  [CONTROL.TEXT]: {
    component: TextField,
    props: {
      variant: 'outlined',
      fullWidth: true,
      onChange: (key: string, value: string, dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name: key, value }))
      },
    } as TextFieldProps,
  },
  [CONTROL.NUMBER]: {
    component: TextField,
    props: {
      variant: 'outlined',
      fullWidth: true,
      type: 'number',
      inputProps: {
        min: 1,
        max: 10,
      },
      onChange: (key: string, value: string, dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name: key, value }))
      },
    },
  },
  [CONTROL.TEXTAREA]: {
    component: FroalaEditor,
    props: {
      onChange: (name: string, value: string, dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name, value }))
      },
    },
  },
  [CONTROL.SWITCH]: {
    component: LabelledSwitch,
    props: {
      switchProps: {
        color: 'primary',
      },
      formControlLabelProps: {
        labelPlacement: 'end',
      },
      onChange: (name: string, value: boolean, dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name, value }))
      },
    },
  },
  [CONTROL.CHECKBOX]: {
    component: TextField,
    props: {
      variant: 'outlined',
      fullWidth: true,
    },
  },
  [CONTROL.CHECKBOX_GROUP]: {
    component: CheckboxGroup,
    props: {
      onChange: (name: string, checked: boolean, dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name, value: checked }))
      },
    },
  },
  [CONTROL.RADIO]: {
    component: TextField,
    props: {
      variant: 'outlined',
      fullWidth: true,
    },
  },
  [CONTROL.RADIO_GROUP]: {
    component: RadioGroup,
    props: {
      onChange: (name: string, value: string, dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name, value }))
      },
    },
  },
  [CONTROL.GROUP]: {
    component: ControlledFieldGroup,
    props: {
      variant: 'outlined',
      fullWidth: true,
      onChange: (name: string, value: string, dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name, value }))
      },
    },
  },
  [CONTROL.ICON]: {
    component: TextField,
    props: {
      variant: 'outlined',
      fullWidth: true,
    },
  },
  [CONTROL.DATE_RANGE]: {
    component: DateRange,
    props: {
      variant: 'outlined',
      fullWidth: true,
      onChange: (name: string, value: string[], dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name, value }))
      },
    },
  },
  [CONTROL.PERMALINK]: {
    component: PermaLink,
    props: {},
  },
  [CONTROL.ADMIN_EMAILS]: {
    component: AdminEmails,
    props: {},
  },
  [CONTROL.TEXTFIELD_WITH_PERMALINK]: {
    component: TextFieldWithPermaLink,
    props: {
      variant: 'outlined',
      fullWidth: true,
      onChange: (name: string, value: string, dispatch: Dispatch) => {
        dispatch(setToolBuilder({ name, value }))
      },
    },
  },
}

export default featureMappings
